var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnabledOrphansCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "af92pat8ja",
    d: "M0 0h20v17.5H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61 1.667)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gvwr1heknb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#af92pat8ja"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.893 16.776c-.201.175-.352.3-.478.375l-.427.349-.252-.2-.176-.15c-.704-.549-4.249-3.52-5.556-4.818C2.998 11.384 1.565 9.936.71 8.263-.245 6.316-.245 4.47.76 2.771 1.767 1.074 3.628.075 5.765.075c1.634 0 3.168.624 4.224 1.672l.301-.299c.327-.3.68-.55 1.081-.749C12.2.249 13.18 0 14.186 0c2.137 0 4.023 1.024 5.053 2.746 1.006 1.723 1.006 3.545.05 5.442-.804 1.573-2.111 2.946-3.268 4.12-1.105 1.123-3.871 3.47-5.128 4.468zm-.151-6.99L9.233 7.54l1.509-2.246L9.233 3.02C8.43 2.047 7.147 1.473 5.74 1.473c-1.61 0-3.017.75-3.771 1.997-.755 1.299-.755 2.672 0 4.17.729 1.497 2.061 2.82 2.991 3.694l.025.025c1.056 1.048 3.646 3.22 4.878 4.244l.88-1.298-1.509-2.247 1.509-2.272z",
    fill: "#AEB3B7",
    mask: "url(#gvwr1heknb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabledOrphansCs);
export default __webpack_public_path__ + "static/media/enabled-orphans-cs.35b82c9e.svg";
export { ForwardRef as ReactComponent };